import {Project} from 'interfaces/Project';

export default function canGenerateReport(project: Project): boolean {
  return project.sections.length > 0 && project.sections.every((section) => section.tray !== null);
}
